import React, { useEffect, useRef, useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { TabsContent } from "@radix-ui/react-tabs";
import Chats from "./Chats";
import ProfileDropdown from "../ProfileDropdown";
import EditIcon from "../../assets/icons/EditIcon";
import HectorIcon from "../../assets/icons/HectorIcon";
import Dashboard from "./Dashboard";
import { useNavigate, useParams } from "react-router-dom";
import PinDashboardDialog from "../Pin/PinDashboard/PinDashboardDialog";
import { createDashboardAPI, fetchDashboardsAPI } from "../../api/dashboardApi";

const Sidebar = ({
  setNewChat,
  chatList,
  activeChat,
  setActiveChat,
  getAllChats,
  username,
  chatLoading,
  setChatLoading,
  chatListTotalCount,
  chatListLimit,
  sidebarSkipRef,
  page,
  setPage,
  isFetchingResponse,
  stopFetchingResponse,
  setChatList,
  setIsDashboardLoading,
  isDashboardLoading,
  setDashboards,
  dashboards,
}) => {
  const sidebarContainerRef = useRef(null);
  const [toggleSidebar, setToggleSidebar] = useState(true);
  const [infiniteScrollHeight, setInfiniteScrollHeight] = useState(null);
  const [isStopResponseAlertOverlayOpen, setIsStopResponseAlertOverlayOpen] =
    useState(false);
  const navigate = useNavigate();
  const { dashboardId } = useParams();
  const [activeTab, setActiveTab] = useState("chat");
  const [dashboardValue, setDashboardValue] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDashboardDialogLoading, setIsDashboardDialogLoading] =
    useState(false);

  const activeBrand = localStorage.getItem("activeBrand");

  useEffect(() => {
    (async () => {
      const data = await fetchDashboardsAPI({
        activeBrand,
        setIsLoading: setIsDashboardLoading,
      });
      setDashboards(data);
    })();
  }, []);

  useEffect(() => {
    setInfiniteScrollHeight(sidebarContainerRef.current.offsetHeight);
  }, []);

  const newChatClickHandler = () => {
    if (isFetchingResponse) {
      setIsStopResponseAlertOverlayOpen(true);
      return;
    }

    setNewChat(true);
    navigate("/");
  };

  const handleAddDashboard = async () => {
    await createDashboardAPI({
      setIsLoading: setIsDashboardDialogLoading,
      activeBrand,
      label: dashboardValue,
    });

    const data = await fetchDashboardsAPI({
      setIsLoading: setIsDashboardLoading,
      activeBrand,
    });
    setDashboards(data);
    setDashboardValue("");
    setIsDialogOpen(false);
  };

  return (
    <div
      className={`relative bg-zinc-950 duration-300 flex flex-col border-r border-zinc-800 ${
        toggleSidebar ? "w-[300px]" : "w-0"
      } `}
    >
      {toggleSidebar &&
        (activeTab === "chat" ? (
          <div className="flex flex-col w-full justify-center items-center mt-2 ">
            <button
              onClick={newChatClickHandler}
              className="flex flex-row w-[95%] bg-zinc-800 justify-between p-2 rounded-lg items-center text-white hover:bg-zinc-800"
            >
              <div className="text-sm font-semibold flex gap-2 items-center">
                <HectorIcon className="" />
                <span>New chat</span>
              </div>
              <EditIcon className="w-4 h-4" />
            </button>
          </div>
        ) : (
          <div className="flex flex-col w-full justify-center items-center mt-2 ">
            <PinDashboardDialog
              title="Create Dashboard"
              description="Enter a unique name for your new dashboard"
              handleSubmit={handleAddDashboard}
              isDialogOpen={isDialogOpen}
              setIsDialogOpen={setIsDialogOpen}
              value={dashboardValue}
              isLoading={isDashboardDialogLoading}
              onChange={(e) => setDashboardValue(e.target.value)}
            >
              <button
                onClick={newChatClickHandler}
                className="flex flex-row w-[95%] bg-zinc-800 justify-between p-2 rounded-lg items-center text-white hover:bg-zinc-800"
              >
                <div className="text-sm font-semibold flex gap-2 items-center">
                  <HectorIcon className="" />
                  <span>New Dashboard</span>
                </div>
                <EditIcon className="w-4 h-4" />
              </button>
            </PinDashboardDialog>
          </div>
        ))}

      <Tabs
        className="flex flex-col justify-between h-full"
        ref={sidebarContainerRef}
        defaultValue={`${dashboardId ? "dashboard" : "chat"}`}
        onValueChange={(active) => setActiveTab(active)}
      >
        {toggleSidebar && (
          <TabsList className="bg-transparent justify-between px-0 mt-2 w-full">
            <TabsTrigger
              className="w-full rounded-none data-[state=active]:text-zinc-50  data-[state=active]:bg-zinc-950 data-[state=active]:border-b-2 data-[state=active]:border-indigo-500 border-b-2 border-zinc-800"
              value="chat"
            >
              Chat
            </TabsTrigger>
            <TabsTrigger
              className="w-full rounded-none data-[state=active]:text-zinc-50 data-[state=active]:bg-zinc-950 data-[state=active]:border-b-2 data-[state=active]:border-indigo-500 border-b-2 border-zinc-800"
              value="dashboard"
            >
              Dashboard
            </TabsTrigger>
          </TabsList>
        )}

        <div
          onClick={() => setToggleSidebar(!toggleSidebar)}
          className={`group/item absolute top-1/2 -right-6 z-10 cursor-pointer w-7 border-gray-800 rounded-full p-2 ${
            !toggleSidebar && "rotate-180"
          }`}
        >
          <div className="h-[11px] -mb-[3.5px] duration-300 bg-zinc-500 w-1 rounded-full group-hover/item:bg-zinc-400 group-hover/item:rotate-[15deg]"></div>
          <div className="h-[11px] bg-zinc-500 duration-300 w-1 rounded-full group-hover/item:bg-zinc-400 group-hover/item:rotate-[-15deg]"></div>
        </div>

        {toggleSidebar && (
          <>
            <TabsContent value="chat">
              <Chats
                infiniteScrollHeight={infiniteScrollHeight}
                setNewChat={setNewChat}
                chatList={chatList}
                getAllChats={getAllChats}
                activeChat={activeChat}
                setActiveChat={setActiveChat}
                username={username}
                chatLoading={chatLoading}
                setChatLoading={setChatLoading}
                setChatList={setChatList}
                chatListTotalCount={chatListTotalCount}
                chatListLimit={chatListLimit}
                sidebarSkipRef={sidebarSkipRef}
                setPage={setPage}
                page={page}
                isFetchingResponse={isFetchingResponse}
                stopFetchingResponse={stopFetchingResponse}
                isStopResponseAlertOverlayOpen={isStopResponseAlertOverlayOpen}
                setIsStopResponseAlertOverlayOpen={
                  setIsStopResponseAlertOverlayOpen
                }
              />
            </TabsContent>

            <TabsContent value="dashboard">
              <Dashboard
                infiniteScrollHeight={infiniteScrollHeight}
                setIsStopResponseAlertOverlayOpen={
                  setIsStopResponseAlertOverlayOpen
                }
                isFetchingResponse={isFetchingResponse}
                isStopResponseAlertOverlayOpen={isStopResponseAlertOverlayOpen}
                stopFetchingResponse={stopFetchingResponse}
                dashboardId={dashboardId}
                isLoading={isDashboardLoading}
                dashboards={dashboards}
              />
            </TabsContent>
          </>
        )}

        {toggleSidebar && <ProfileDropdown username={username} />}
      </Tabs>
    </div>
  );
};

export default Sidebar;
